module.exports = __webpack_public_path__ + "static/media/1899cc904de70c71d4102d29170fd13.65b9eb27.jpg";